import { SortDirection } from '@angular/material/sort';

import { ResearchType } from '@empathy/global/data';

export class FetchRequest {
  pageIndex: number;
  pageSize: number;
  sort: string;
  sortDirection: SortDirection;
  filter: string;
  filterType: ResearchType | null;

  constructor(pageIndex?: number, pageSize?: number, sort?: string, sortDirection?: SortDirection, filter?: string, filterType?: ResearchType | null) {
    this.pageIndex = pageIndex ?? 1;
    this.pageSize = pageSize ?? 10;
    this.sort = sort ?? 'CreatedDateTime';
    this.sortDirection = sortDirection === '' || !sortDirection ? 'desc' : sortDirection;
    this.filter = filter;
    this.filterType = filterType;
  }
}
